module.exports = __webpack_public_path__ + "static/media/ic-more.c207009a.svg";